<section class="header">
    <h2>Customer Hierarchy</h2>
</section>
<main class="customer-hierarchy">
    <div class="row">
        <aside class="col-sm-3">
            <div class="customers-assigned d-flex flex-row align-items-center justify-content-center">
                <h4>Customers assigned</h4>
                <div class="no ml-2">{{totalAssignedCustomers}}&nbsp;/&nbsp;{{totalAssignableCustomers}}</div>
            </div>
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodeToggle>
                    <a (click)="getHierarchy(node.level,node)">{{node.name}}</a>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodeToggle>
                    <a (click)="getHierarchy(node.level,node)">{{node.name}}</a>
                </mat-tree-node>
            </mat-tree>
        </aside>

        <section class="col-sm-9 right-section" style="min-height: 1110px;">
            <section class="d-flex main-heading ie_head">
                <p>&nbsp;&nbsp;&nbsp;{{!selectedNode ? treeSource[0]?.name: selectedNode?.name }} </p>
            </section>
            <section class="d-flex-col">
                <section class="d-flex-col Fields-container name-input">
                    <label for="name">Name </label>
                    <div class="d-flex name-section" *ngIf="!editName">
                        <div class="d-flex">{{!selectedNode ? treeSource[0]?.name: selectedNode?.name}}</div>
                        <div class="d-flex">
                            <a class="edit-name-level" (click)="editNameField()">
                                <img src="assets/icons/{{baseSiteId}}/editIcon.png" alt="Edit">
                                Edit</a>
                        </div>
                    </div>
                    <div class="d-flex-col edit-name-section" *ngIf="editName">
                        <form [formGroup]="nameForm">
                            <section class="Fields-container form-group">
                                <input class="Fields-input form-control name" formControlName="name" type="text" />
                                <section *ngIf="(f.name.touched || f.name.dirty) && f.name.errors?.required"
                                    class="error">
                                    This field is required
                                </section>
                            </section>
                            <div class="btn-grp">
                                <button type="button" class="btn-secondary" (click)="editNameField()">
                                    Cancel</button>
                                <button type="button" type="submit" [disabled]="!nameForm.valid || !nameBtnEnable"
                                    class="btn-primary update-node" (click)="updateName()">
                                    Save</button>
                            </div>
                            <div>
                            </div>
                        </form>
                    </div>
                </section>
            </section>
            <section class="d-flex-col child-levels" *ngIf="assignedCustmerList.length === 0">
                <p class="label">Child levels</p>
                <div class="no-data" *ngIf="!selectedNode ? treeSource[0]?.childNodes.length == 0 :
                selectedNode?.childNodes.length == 0">
                    <p>There are no child levels assigned to this level.</p>
                </div>
                <ul class="d-flex-col levels-container" *ngIf="!selectedNode ? treeSource[0]?.childNodes.length > 0 :
                selectedNode?.childNodes.length > 0">
                    <ng-container
                        *ngFor="let item of ( !selectedNode ? treeSource[0]?.childNodes : selectedNode?.childNodes)">
                        <li class="d-flex each-lvl">
                            <div class="d-flex lvl-name">{{item.name}}</div>
                            <div class="d-flex remove delete-popover-container">  
                                <a [class]="removelevel" [ngbPopover]="popContentDelete" *ngIf="item.isRemovable"
                                    [popoverTitle]="popTitleDelete" triggers="manual" #p1="ngbPopover" placement="top-right"
                                    class="trash delete" (click)="toggle(p1,'level', item.uid)"><img
                                        src="assets/icons/{{baseSiteId}}/trash.svg" alt="">Remove</a>
                            </div>
                        </li>
                    </ng-container>

                </ul>
                <button class="btn-secondary" data-toggle="modal" data-target="#addchildlevelpopup"
                    (click)="openChildLevelPopup(selectedNode?.uid || treeSource[0].uid)">
                    Add child levels
                </button>
            </section>
            <section class="d-flex-col assigned-customers" *ngIf="!selectedNode ? treeSource[0]?.childNodes.length == 0:
             selectedNode?.childNodes.length == 0">
                <p class="label">
                    Assigned Customers
                </p>
                <div class="no-data" *ngIf="assignedCustmerList.length == 0">
                    <p>There are no customers assigned to this level.</p>
                </div>
                <ul class="d-flex-col customers-container" *ngIf="assignedCustmerList.length > 0">
                    <li class="d-flex head-section">
                        <div class="d-flex check_customer">
                            <label class="checkall_label">
                                <input type="checkbox" id="checkBox" [(ngModel)]="masterSelected" class="cust_chkall"
                                    name="cust_chk" (change)="checkUncheckAll()">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="d-flex s-no">#</div>
                        <div class="d-flex name">
                            Name
                        </div>
                        <div class="d-flex address">
                            Address
                        </div>
                    </li>
                    <li class="d-flex each-customer" *ngFor="let customer of assignedCustmerList; let i = index">
                        <div class="d-flex check_customer">
                            <label class="check_label">
                                <input type="checkbox" id="checkBox" class="cust_chk" name="cust_chk"
                                    [(ngModel)]="customer.isSelected" (change)="isAllSelected()">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="d-flex s-no">
                            {{customer?.uidNonLeadingZero}}
                        </div>
                        <div class="d-flex name">
                            {{customer?.abbreviatedName}}
                        </div>
                        <div class="d-flex address">
                            {{customer?.soldToAddress?.formattedAddress}}
                        </div>
                        <div class="d-flex remove delete-popover-container">
                            <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual"
                                #p1="ngbPopover" placement="top-right" class="trash delete"
                                (click)="toggle(p1, 'customer', customer.uid)"><img
                                    src="assets/icons/{{baseSiteId}}/trash.svg" alt="">
                                Remove
                            </a>
                        </div>
                    </li>
                </ul>
                <div *ngIf="customerCheckedList.length > 0" class="customer-selection">
                    <div>Customers selected: {{customerCheckedList.length}}</div>
                    <div class="customer-enablebtn remove delete-popover-container">
                        <button class="btn-secondary" (click)="cancelCustomer()">
                            Cancel
                        </button>
                        <button class="btn-primary" [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete"
                            triggers="manual" #p1="ngbPopover" placement="top-right" (click)="toggle(p1, 'customer')">
                            <img src="assets/icons/{{baseSiteId}}/trash.svg" alt="">
                            Remove
                        </button>
                    </div>
                </div>
                <button class="btn-secondary" data-toggle="modal" data-target="#assign-customers-popup"
                    data-backdrop="static" (click)="openAssignCustomer(selectedNode?.uid || treeSource[0].uid)"
                    *ngIf="customerCheckedList.length == 0">
                    Assign customers
                </button>
            </section>
            <section class="d-flex-col assigned-approvers">
                <p class="label">Assigned approvers</p>
                <div class="no-data" *ngIf="assignedApproverList?.length == 0">
                    <p>There are no approvers assigned to this level. This level will inherit approvers from parent
                        level nodes until an approver is assigned.</p>
                </div>
                <ul class="d-flex-col approvers-container" *ngIf="assignedApproverList?.length > 0">
                    <li class="d-flex head-section">
                        <div class="d-flex name">
                            Name
                        </div>
                        <div class="d-flex ch-threshold">
                            Threshold
                        </div>
                        <div class="d-flex delegates">
                            Delegates
                        </div>
                        <div class="d-flex phone">
                            Phone
                        </div>
                    </li>
                    <li class="d-flex each-approver" *ngFor="let appDel of assignedApproverList; let i = index">
                        <ul>
                            <li class="d-flex approver-del">
                                <div class="d-flex name">
                                    {{appDel?.approver?.name}}
                                </div>
                                <div class="d-flex ch-threshold">
                                    {{appDel?.thresholdValue}}
                                </div>
                                <div class="d-flex delegates">
                                </div>
                                <div class="d-flex phone">
                                    <p> {{appDel?.phoneNo}} </p>
                                </div>
                                <div class="d-flex remove delete-popover-container">
                                    <a class="edit"
                                        (click)="openAssignApprover('edit',selectedNode?.uid || treeSource[0].uid, appDel)">
                                        <img src="assets/icons/{{baseSiteId}}/editIcon.png" alt="">
                                        Edit</a>
                                    <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual"
                                        #p1="ngbPopover" placement="top-right" class="trash delete"
                                        (click)="toggle(p1, 'Approvers', appDel.uid)"><img
                                            src="assets/icons/{{baseSiteId}}/trash.svg" alt="">
                                        Remove</a>
                                </div>
                            </li>
                            <li class="d-flex approver-del"
                                *ngFor="let del of appDel.delegatesList; let delIndex = index">
                                <div class="d-flex name">
                                </div>
                                <div class="d-flex ch-threshold">
                                </div>
                                <div class="d-flex delegates">
                                    {{del?.delegate?.name}}
                                </div>
                                <div class="d-flex phone">
                                    {{del?.phoneNo}}
                                </div>
                                <div class="d-flex remove delete-popover-container">
                                    <a class="edit"
                                        (click)="openApproverDelegate(delIndex, appDel, selectedNode?.uid || treeSource[0].uid)">
                                        <img src="assets/icons/{{baseSiteId}}/editIcon.png" alt="">
                                        Edit</a>
                                    <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual"
                                        #p1="ngbPopover" placement="top-right" class="trash delete"
                                        (click)="toggle(p1, 'Delegates', del.uid)"><img
                                            src="assets/icons/{{baseSiteId}}/trash.svg" alt="">
                                        Remove</a>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
                <button class="btn-secondary" id="add-approver-btn" data-toggle="modal" data-target="#approvers-popup"
                    (click)="openAssignApprover('add', selectedNode?.uid || treeSource[0].uid)">
                    Assign approvers
                </button>
            </section>
        </section>
    </div>
    <!-- modal templates can be created here  -->
    <!-- Popover for delete operation -->
    <ng-template #popTitleDelete let-title="title">
        Remove this {{title}} ?
    </ng-template>
    <ng-template #popContentDelete let-popover="popoverInstance" let-id="id" let-item="title">
        <button type="reset" class="popover-close btn btn-secondary popover-cancel-button"
            data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(popover)">
            Cancel
        </button>
        <button class="btn btn-primary popover-cancel-button" type="submit" (click)="removeEntries(popover, id, item)">
            Remove
        </button>
    </ng-template>
</main>